<template>
    <div>
        <modal class="new-modal-default custom-fixed-height" :name="modal_name" transition="nice-modal-fade" :delay="100" :width="840"
            :height="460" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" v-bind:click-to-close="false">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header">
                    <div></div>
                    <div>
                        <span
                            class="v-modal-dialog-title v-modal-title">{{meeting_id ? 'EDIT SCHEDULE MEETING' : 'ADD SCHEDULE MEETING'}}</span>
                    </div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left"
                            @click="hideScheduleMeeting"></span>
                    </div>
                </div>
                <div class="v-modal-body">
                    <div class="v-modal-layout px-2">
                        <div>
                            <span class="text-secondary fs-14 fw-600 ml-2">Add Meeting Title<sup class="text-danger fs-14 ml-02">*</sup></span>
                            <textarea-autosize v-validate="'required'" name="meeting_title"
                                class="digi-textarea white-background bordered mt-3" maxlength="50"
                                v-model="meeting_title" placeholder="Enter Title" style="height: 3em;" />
                            <span class="input-field-length float-right">{{ meeting_title.length }}/50</span>
                            <span class="text-danger" v-show="errors.has('meeting_title')"
                                style="text-transform: none !important;">Meeting Title is Required</span>
                        </div>
                        <div class="mt-3">
                            <span class="text-secondary fs-14 fw-600 ml-2 ">Agenda of the Meeting</span>
                            <textarea-autosize name="meeting_agenda"
                                class="digi-textarea white-background bordered mt-3" maxlength="1000"
                                v-model="meeting_agenda" placeholder="Enter Agenda" style="height: 3em;" />
                            <span class="input-field-length float-right">{{ meeting_agenda.length }}/1000</span>
                            <span class="text-danger " v-show="errors.has('meeting_agenda')"
                                style="text-transform: none !important;">Meeting Agenda is Required</span>
                        </div>
                        <div class="row mt-6">
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <div class="text-black fw-600 fs-14">Schedule At</div>
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-lg-7 col-md-7 col-sm-12 mt-3">
                                            <div class="w-100">
                                                <span class="input-label fw-500  fs-14">Start Date<sup class="text-danger fs-14 ml-02">*</sup></span>
                                                <div class="d-flex align-items-center"
                                                    style="margin-top: .7rem !important;">
                                                    <date-picker v-validate="'required'" @change="clearEndDate()"
                                                        :not-before="new Date()" name="schedule_reminder_date"
                                                        class="meetinfdatetime fullBorderCalendar mx-left calendar-edit-per mt-1"
                                                        v-model="schedule_start_date" value-type="format" lang="en"
                                                        type="date" format="YYYY-MM-DD" :clearable="false"
                                                        :editable="false"></date-picker>
                                                </div>
                                                <div class="text-danger float-left pl-0"
                                                    v-show="errors.has('schedule_reminder_date')"
                                                    style="text-transform: none !important;">Date is Required</div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-5 col-sm-12 mt-3"
                                            :class="{ 'hide-state' : allDayTime}">
                                            <div class="w-100">
                                                <span class="input-label fw-500  fs-14 whiteSpace">Start Time<sup class="text-danger fs-14 ml-02">*</sup></span>
                                                <el-select v-validate="!allDayTime ? {required:true} : {required:false}" name="schedule_reminder_time"
                                                    class="mt-2 schedule_time" v-model="schedule_start_time"
                                                    style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;"
                                                    placeholder="Start Time" :popper-append-to-body="false">
                                                    <el-option v-for="(item, index) in time_format" :key="index"
                                                        :label="item" :value="item">
                                                    </el-option>
                                                </el-select>
                                                <div class="text-danger float-left pl-0"
                                                    v-show="errors.has('schedule_reminder_time')"
                                                    style="text-transform: none !important;">Time is Required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12">
                                <div class="text-black fw-600 fs-14 location-text">Location</div>
                                <div class="d-flex location-margin">
                                    <div class="gMap" style="position:relative;width:100%;">
                                        <gmap-autocomplete class="inputFieldNoBorder mt-0" id="autocompleteInput"
                                            placeholder="Search Location" @place_changed="setPlace" :value="location"
                                            style="padding: 8px 32px 8px 18px !important; height: 40px;">
                                        </gmap-autocomplete>
                                        <img src="/static/images/images-new-theme/icons/marker_pin.svg"
                                            style="position: absolute;right: 12px;bottom: 12px;" />
                                    </div>
                                    <div class="form-group gMap ml-4 pt-0" style="cursor: pointer;"
                                        @click="getLocation">
                                        <img src="/static/images/images-new-theme/icons/GPS 2.svg"
                                            style="height: 40px;" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 val-mes-dis">
                                <div class="text-black fw-600 invite-text fs-14">Invite<sup class="fs-14 ml-02 text-danger">*</sup></div>
                                <span class="input-label fw-500"  style="position:relative;top:11px;">Invite Someone</span>
                                <div class="d-flex flex-column mt-5" style="position: relative;margin-top: 2.1rem !important;">
                                    <multiselect v-validate="'required'"  :hide-selected="true" name="invites" class="diginew-multiselect-lightgrey sch-meeting ht_arrow-n custom-prod-ms greyblack icon-height diginew-multiselect-dark-grey" placeholder="Invite"  v-model="invitees" :multiple="true" :close-on-select="true" :show-labels="false" :options="invite_options" :loading="employees_loading" @search-change="searchInvitees" label="email" track-by="email" >
                                        <template slot="option" slot-scope="props" class="d-flex">
                                            {{ props.option.email }}
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfListInvitees" />
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Invitees Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                    <i class="icon-account-plus" style="color: #00448b; position: absolute; right: 0; margin-top: 9px; margin-right: 6px;"></i>
                                </div>
                                <span class="text-danger float-left val-mes" v-show="errors.has('invites')" style="text-transform: none !important;">Invites is Required</span>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-3">
                                <div class="d-flex">
                                    <div class="row">
                                        <div class="col-lg-7 col-md-7 col-sm-12 mt-3">
                                            <div class="w-100">
                                                <span class="input-label fw-500  fs-14">End Date</span>
                                                <div class="d-flex align-items-center" style="margin-top: .7rem !important;">
                                                    <date-picker :disabled="schedule_start_date == null" :clearable="false"
                                                    :editable="false" v-validate="'required'"  name="schedule_reminder_end_date" class="meetinfdatetime mx-left calendar-edit-per" v-model="schedule_end_date" value-type="format" lang="en" :not-before="new Date(schedule_start_date)" type="date" format="YYYY-MM-DD"></date-picker>
                                                </div>
                                                <div class="text-danger float-left pl-0" v-show="errors.has('schedule_reminder_end_date')" style="text-transform: none !important;">End Date is Required</div>
                                            </div>
                                        </div>
                                        <div class="col-lg-5 col-md-5 col-sm-12 mt-3" :class="{ 'hide-state' : allDayTime}">
                                            <div class="w-100">
                                                <span class="input-label fw-500  fs-14">End Time</span>
                                                <el-select v-validate="all_day ? '' : 'required'" name="schedule_reminder_end_time" class="mt-2 schedule_time" v-model="schedule_end_time" style="border-radius: 6px;border: 1px solid rgb(92 92 92) !important;"
                                                placeholder="End Time" :popper-append-to-body="false">
                                                    <el-option
                                                        v-for="(item, index) in time_format"
                                                        :key="index"
                                                        :label="item"
                                                        :value="item">
                                                    </el-option>
                                                </el-select>
                                                <div class="text-danger float-left pl-0" v-show="errors.has('schedule_reminder_end_time')" style="text-transform: none !important;">Time is Required</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mt-5">
                                <div class="text-black fw-600  fs-14">Products</div>
                                <div class="d-flex flex-column" style="position: relative;margin-top: 1em;">
                                    <multiselect :max="10"
                                        class="diginew-multiselect-lightgrey custom-prod-ms greyblack icon-height diginew-multiselect-dark-grey"
                                        placeholder="Select Product" name="product"
                                        label="name" open-direction="bottom"
                                        v-model="selected_products" @open="resetData('name')"
                                        :options="products_options" track-by="name"
                                        :multiple="true" :searchable="true" :internal-search="true"
                                        :clear-on-select="false" :close-on-select="true" :options-limit="3000"
                                        :max-height="200" :show-no-results="true" :hide-selected="false"
                                        :blockKeys="['Delete']" :limit="1" :limit-text="limitProducts" :loading="products_loading" @search-change="searchProuctName"
                                    >
                                        <template slot="option" slot-scope="props" class="d-flex">
                                            {{ props.option.name }}
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfProductName" />
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Products Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect>
                                    <!-- <multiselect name="products" :limit="1" :limit-text="limitProducts" :max="10" class="diginew-multiselect-lightgrey custom-prod-ms greyblack icon-height diginew-multiselect-dark-grey lead-meeting-products" placeholder="Select Product" v-model="selected_products" :multiple="true" :close-on-select="true" :show-labels="false" :options="products" :loading="products_loading" @search-change="searchProduct" label="name" trackBy="id">
                                        <template slot="option" slot-scope="props" class="d-flex">
                                            {{ props.option.name }}
                                        </template>
                                        <template slot="afterList">
                                            <div v-observe-visibility="reachedEndOfProducts" />
                                        </template>
                                        <template slot="noOptions">
                                            <div class="text-secondary text-center fw-600">Products Not Found</div>
                                        </template>
                                        <template slot="noResult">
                                            <div class="text-secondary text-center fw-600">No Results Found</div>
                                        </template>
                                    </multiselect> -->
                                </div>
                                <span class="text-danger float-left" v-show="errors.has('product')" style="text-transform: none !important;">Products is Required</span>
                            </div>
                        </div>
                        <div class="d-flex w-100 mt-4 align-items-center">
                            <!-- <input v-model="all_day" type="checkbox" /> -->
                            <el-checkbox v-model="all_day" @change="allDayChecked"></el-checkbox>
                            <span class="ml-2">All Day</span>
                        </div>
                        <div class="mt-5">
                            <div class="text-black fw-600  fs-14">Description</div>
                            <textarea-autosize class="bg-transparent px-2 pt-1 pb-6 mt-1 description"
                                v-model="description" placeholder="Enter Text Here.." :min-height="80" :max-height="80"
                                maxlength="200" data-vv-scope="profile_data" data-vv-as="About" name="about" />
                            <span class="input-field-length float-right">{{ description.length }}/200</span>

                        </div>
                    </div>
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="v-modal-dialog-actions d-flex justify-content-center align-items-center mt-2">
                    <button class="btn new-cancel-button ml-2 mr-2" @click="hideScheduleMeeting">Cancel</button>
                    <button class="btn new-save-button ml-2 mr-2" @click="saveMeeting()">Save</button>
                </div>
                <div v-else class="v-modal-dialog-actions d-flex justify-content-center align-items-center mt-2">
                    <button class="btn btn-des-small ml-2 mr-2" style="color: #00448b; border: 1px solid transparent !important; background: #fff;" disabled>Cancel</button>
                    <button class="btn btn-des-small ml-2 mr-2" style="color: #fff; background: #00448b; border: 1px solid transparent; position: relative;" disabled>Save
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <success-message v-if="success_lead" :message="message" modal_name="success-message" @hideSuccess="hideSuccess">
        </success-message>
    </div>
</template>

<script>
    const SuccessMessage = () => import("../SuccessMessage");
    import VueTextareaAutosize from "vue-textarea-autosize";
    import {
        SweetModal
    } from 'sweet-modal-vue';
    import globals from '../globals';
    import axios from "axios";
    import leads from "../mixins/leads"
    import productList from "../mixins/productList"
    import { HollowDotsSpinner } from "epic-spinners";
    import product_lazy_loading from "../mixins/product_lazy_loading"
    import {
        debounce
    } from 'lodash';
    export default {
        data() {
            return {
                disableButtonAndDisplayLoader: false,
                meeting_title: "",
                meeting_agenda: "",
                schedule_start_date: null,
                schedule_start_time: null,
                schedule_end_date: null,
                schedule_end_time: null,
                invitees: null,
                invite_options: [],
                selected_products: [],
                is_loading_invite: false,
                is_loading_product: false,
                search_key: "",
                time_format: [
                    '00:00',
                    '00:15',
                    '00:30',
                    '00:45',
                    '01:00',
                    '01:15',
                    '01:30',
                    '01:45',
                    '02:00',
                    '02:15',
                    '02:30',
                    '02:45',
                    '03:00',
                    '03:15',
                    '03:30',
                    '03:45',
                    '04:00',
                    '04:15',
                    '04:30',
                    '04:45',
                    '05:00',
                    '05:15',
                    '05:30',
                    '05:45',
                    '06:00',
                    '06:15',
                    '06:30',
                    '06:45',
                    '07:00',
                    '07:15',
                    '07:30',
                    '07:45',
                    '08:00',
                    '08:15',
                    '08:30',
                    '08:45',
                    '09:00',
                    '09:15',
                    '09:30',
                    '09:45',
                    '10:00',
                    '10:15',
                    '10:30',
                    '10:45',
                    '11:00',
                    '11:15',
                    '11:30',
                    '11:45',
                    '12:00',
                    '12:15',
                    '12:30',
                    '12:45',
                    '13:00',
                    '13:15',
                    '13:30',
                    '13:45',
                    '14:00',
                    '14:15',
                    '14:30',
                    '14:45',
                    '15:00',
                    '15:15',
                    '15:30',
                    '15:45',
                    '16:00',
                    '16:15',
                    '16:30',
                    '16:45',
                    '17:00',
                    '17:15',
                    '17:30',
                    '17:45',
                    '18:00',
                    '18:15',
                    '18:30',
                    '18:45',
                    '19:00',
                    '19:15',
                    '19:30',
                    '19:45',
                    '20:00',
                    '20:15',
                    '20:30',
                    '20:45',
                    '21:00',
                    '21:15',
                    '21:30',
                    '21:45',
                    '22:00',
                    '22:15',
                    '22:30',
                    '22:45',
                    '23:00',
                    '23:15',
                    '23:30',
                    '23:45',
                ],
                description: '',
                reminder_gap: null,
                reminder_number: null,
                repear_end_date: null,
                repear_start_date: null,
                location: "",
                eventData: {
                    location: {
                        city: "",
                        country: "",
                    }
                },
                all_day: false,
                warning_msg: null,
                success_lead: false,
                message: '',
                //employees
                employees_loading: false,
                temp_employees: [],
                employee_count: 0,
                employee_scrollable: false,
                employee_visible: false,
                store_invitees: [],
                allDayCheck: false,
                allDayTime: false,
                selected_field: '',
                products_options: [],
                products_count: 0,
                products_scrollable: false,
            }
        },
        props: ["modal_name", "lead_current_stage", "meeting_id", "schedule_data", "lead_meeting_id","lead_edit_stage","stage_edit_mode", "selected_lead_id"],
        mixins: [leads, product_lazy_loading, productList],
        methods: {
            resetData(type){
                this.selected_field = type
                this.products_options = [];
                this.products_count = 0;
            },
            async searchProuctNameDebouncer(search){
                this.products_loading = true
                this.products_count = 0
                let params = {
                    skip: this.skip,
                    limit: 10,
                    search_key: search,
                    sort_key: "name",
                    sort_value: 1,
                    category_ids:[],
                    sub_category_ids:[],
                    product_type_ids:[],
                    product_ids:[],
                    brand_ids:[],
                    outlet_ids:[],
                    status:[],  
                    visibility:"Manufacturing"
                }
                let response = await this.ProductsList(params)
                this.products_options = response.response.result
                
                this.products_count = this.products_options.length
                this.products_loading = false
            },
            async reachedEndOfProductName(reached){
                if(reached){
                    if(this.products_scrollable == false){
                        this.products_loading = true
                        let response = await this.ProductsList({
                            skip: this.products_count,
                            limit: 10,
                            search_key: '',
                            sort_key: "name",
                            sort_value: 1,
                            category_ids:[],
                            sub_category_ids:[],
                            product_type_ids:[],
                            product_ids:[],
                            brand_ids:[],
                            outlet_ids:[],
                            status:[],  
                            visibility:"Manufacturing"
                        } )
                        let temp_products_options = response.response.result.length;
                        if(response.response.filter_data.skip == this.products_count){
                            if(temp_products_options > 0){
                                let tempfiles = response.response.result
                                // tempfiles.forEach(el => {
                                //     if(el[this.selected_field] != '' && el.hasOwnProperty(this.selected_field)){
                                //         this.products_options.push(el)
                                //     }
                                // })
                                // let uniqueArray = this.products_options.filter((value, index_dd) => {
                                //     const _value = value[this.selected_field];
                                //     return index_dd === this.products_options.findIndex(obj => {
                                //         return obj[this.selected_field] === _value;
                                //     });
                                // });
                                this.products_options = tempfiles
                                this.products_count += response.response.result.length;
                                this.products_loading = false
                            } else {
                                this.products_scrollable = true
                                this.products_loading = false
                            }
                            this.products_scrollable = false
                        }
                    }
                }
            },
            //limit the products count
            limitProducts(count) {
                return `+ ${count} more`;
            },
            //clear the end date
            clearEndDate() {
                this.schedule_start_time = ""
                this.schedule_end_date = ""
                this.schedule_end_time = ""
                this.$forceUpdate()
            },
            //hide the success modal
            hideSuccess() {
                this.success_lead = false;
                setTimeout(() => {
                    this.disableButtonAndDisplayLoader = false;
                    this.$emit("updateLeads")
                    this.hideScheduleMeeting()
                }, 500);
            },
            //split the address
            /**@params = place */
            setPlace(place) {
                this.location = place.formatted_address;
                let address = place.formatted_address.split(", ");
                this.eventData.location.city = address[address.length - 3];
                this.eventData.location.country = address[address.length - 1];
            },
            //get the location data
            getLocation() {
                if (navigator.geolocation) {
                    // timeout at 60000 milliseconds (60 seconds)
                    var options = {
                        enableHighAccuracy: false,
                        timeout: 30000, // milliseconds (30 seconds)
                        maximumAge: 600000
                    }; // milliseconds (10 minutes)
                    navigator.geolocation.getCurrentPosition(
                        this.showLocation,
                        this.errorHandler,
                        options
                    );
                } else {
                    alert("Sorry, browser does not support geolocation!");
                }
            },
            //checked the status of all day checkbox
            allDayChecked() {
                if (this.all_day == true) {
                    this.allDayTime = true
                    this.$forceUpdate()
                } else {
                    this.allDayTime = false
                    this.$forceUpdate()
                }
            },
            //show the location details
            /**@params = position */
            showLocation(position) {
                let latlongvalue = position.coords.latitude + "," + position.coords.longitude;
                let calllatlong = axios.create();
                delete calllatlong.defaults.headers.common['Authorization'];
                calllatlong.post("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + latlongvalue +
                        "&key=AIzaSyCQSEwELtCrUrLSfsqU0wX7QAHbLVQzUrY")
                    .then(response => {
                        let address = response.data.results[0].formatted_address.split(", ");
                        this.eventData.location.city = address[address.length - 3];
                        this.eventData.location.country = address[address.length - 1];
                        this.location = this.eventData.location.city + ',' + this.eventData.location.country;
                    }).catch(e => {
                        // this.errors.push(e)
                    });
            },
            errorHandler(err) {
                if (err.code == 1) {
                    // alert("Error: Access is denied!");
                } else if (err.code == 2) {
                    // alert("Error: Position is unavailable!");
                }
            },
            //API call for the search invitees
            /**@params = item */
            async searchInviteesDebouncer(item) {
                this.employees_loading = true
                /**@params = limit, @params = skip , @params = search_key , @params = company_id, @params = sort_key, @params = sort_value*/
                let params = {
                    skip: 0,
                    limit: 50,
                    search_key: item,
                    company_id: this.loggedInUser.company_id,
                    sort_key: 'full_name',
                    sort_value: 1
                }
                let response = await this.getAssigned(params)
                this.invite_options = response.response
                this.invite_options.forEach(x => {
                    this.store_invitees.push(x)
                })
                //filtering the same data from invite options to avoid redundancy
                this.invite_options = this.invite_options.filter((thing, index) => {
                    const payload = JSON.stringify(thing);
                    return index === this.invite_options.findIndex(obj => {
                        return JSON.stringify(obj) === payload;
                    });
                });
                this.employee_count = this.invite_options.length
                this.employees_loading = false
                this.employee_scrollable = false
            },
            //lazy loading of invites
            async reachedEndOfListInvitees(reached) {
                this.employee_visible = reached
                if (reached) {
                    if (this.employee_scrollable == false) {
                        this.employees_loading = true
                        /**@params = limit, @params = skip , @params = search_key , @params = company_id, @params = sort_key, @params = sort_value*/
                        let response = await this.getAssigned({
                            skip: this.employee_count,
                            limit: 10,
                            search_key: "",
                            company_id: this.loggedInUser.company_id,
                            sort_key: 'full_name',
                            sort_value: 1
                        })
                        this.temp_employees = response.response.length;
                        if (response.skip == this.employee_count) {
                            if (this.temp_employees > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.invite_options.push(el);
                                });
                                this.invite_options = this.invite_options.filter((thing, index) => {
                                    const payload = JSON.stringify(thing);
                                    return index === this.invite_options.findIndex(obj => {
                                        return JSON.stringify(obj) === payload;
                                    });
                                });
                                this.employee_count += response.response.length;
                                this.employees_loading = false
                            } else {
                                this.employee_scrollable = true
                                this.employees_loading = false
                            }
                        }
                        this.employees_loading = false
                    }
                }
            },
            //hide the schedule meetings
            hideScheduleMeeting() {
                this.$modal.hide(this.modal_name);
                this.$emit("hideScheduleMeeting");
            },
            //Api call to save/update the schedule meetings
            saveMeeting() {
                this.$validator.validateAll().then(async result => {
                    if (this.location) {
                        this.create_meeting['location'] = this.location
                    }
                    if (this.description) {
                        this.create_meeting['description'] = this.description
                    }
                    if (result) {
                        try{
                            this.disableButtonAndDisplayLoader = true;
                            let response
                            if (this.meeting_id) {
                                this.message = "Meeting Updated Successfully"
                                response = await this.updateMeeting(this.meeting_id, this.create_meeting)
                                // this.disableButtonAndDisplayLoader = true;
                            } else {
                                this.message = "Meeting Scheduled Successfully"
                                response = await this.createMeeting(this.create_meeting)
                                // this.disableButtonAndDisplayLoader = true;
                            }
                            this.success_lead = true;
                            setTimeout(() => {
                                this.$modal.show('success-message');
                            }, 1000);
                            this.disableButtonAndDisplayLoader = false;
                        } catch(error) {
                            this.warning_msg = error
                            this.$refs.warning_modal.open();
                            setTimeout(() => {
                                this.disableButtonAndDisplayLoader = false;
                                this.$refs.warning_modal.close();
                            }, 2000);
                        }
                    }
                })
            },
            //API call to get details of the meetings
            async loadMeetingById() {
                let type = localStorage.getItem("leads_type");
                let response
                if (type == 'Archive') {
                    response = await this.getArchiveMeetingDetails(this.meeting_id)
                } else if (type == 'Manual') {
                    response = await this.getMeetingDetails(this.meeting_id)
                } else {
                    response = await this.getConvertedMeetingDetails(this.meeting_id)
                }
                this.meeting_title = response.response.meeting_title
                this.meeting_agenda = response.response.meeting_agenda
                this.schedule_start_date = response.response.schedule_start_date
                this.schedule_start_time = response.response.schedule_start_time
                this.schedule_end_date = response.response.schedule_end_date
                this.schedule_end_time = response.response.schedule_end_time
                this.description = response.response.description
                this.location = response.response.location
                this.all_day = response.response.schedule_all_day
                let temp_products = response.response.products
                let temp_selected_products = []
                temp_products.forEach((el_product, el_product_index) => {
                    temp_selected_products.push({
                        id: el_product.product_name,
                        name: el_product.product_name
                    })
                })
                this.selected_products = temp_selected_products
                // this.selected_products = []
                // response.response.products.forEach(x => {
                //     this.selected_products.push({
                //         id: x.id,
                //         name: x.name
                //     })
                // })
                this.invitees = []
                response.response.invite_email.forEach(x => {
                    this.invitees.push({
                        email:x
                    })
                })
                setTimeout(() => {
                    this.employees_loading = false
                }, 2000);
                if (this.all_day == true) {
                    this.allDayTime = false
                }
            }
        },
        components: {
            SweetModal,
            SuccessMessage,
            VueTextareaAutosize,
            HollowDotsSpinner,
        },
        computed: {
            searchProuctName(){
                return debounce(this.searchProuctNameDebouncer, 500)
            },
            loggedInUser() {
                return this.$store.state.loggedInUser;
            },
            //adding all fields data to pass as params in the save meeting api.
            create_meeting() {
                let stage_data = ''
                let lead_data_id = ""
                if (this.lead_current_stage == '' || this.lead_current_stage == undefined) {
                    stage_data = this.schedule_data
                } else {
                    stage_data = this.lead_current_stage
                }
                if (this.lead_meeting_id == '' || this.lead_meeting_id == undefined) {
                    lead_data_id = this.$route.params.id

                } else {
                    lead_data_id = this.lead_meeting_id
                }
                let temp_products = []
                this.selected_products.forEach((el_product, el_product_index) => {
                    temp_products.push({
                        product_id: el_product._id,
                        product_name: el_product.name
                    })
                })
                return {
                    meeting_title: this.meeting_title,
                    meeting_agenda: this.meeting_agenda,
                    schedule_start_date: this.schedule_start_date,
                    schedule_start_time: this.schedule_start_time,
                    schedule_end_date: this.schedule_end_date,
                    schedule_end_time: this.schedule_end_time,
                    schedule_all_day: this.all_day,
                    invite_email: this.invitees.map(x => {
                        return x.email
                    }),
                    lead_id: lead_data_id ? lead_data_id : this.selected_lead_id,
                    stage_name: this.stage_edit_mode == 'off' ? stage_data : this.lead_edit_stage,
                    lead_products: temp_products ? temp_products : this.selected_products
                    // this.selected_products ? this.selected_products.map(x => {
                    //     return x.id
                    // }) : []
                }
            }
        },
        async mounted() {
            //if we have a meeting id
            if (this.meeting_id) {
                this.loadMeetingById()
            }
        },
        created() {
            //Added debounce for all search methods
            this.searchProduct = debounce(this.searchProductDebouncer, 500)
            this.searchInvitees = debounce(this.searchInviteesDebouncer, 500)
        }
    }
</script>
<style scoped>

    .description {
        border: solid 1px #000 !important;
        border-radius: 5px !important;
        text-transform: capitalize;
        color: #000000;
        width: 100%;
    }
    .location-margin {
        margin-top: 3em
    }
    .input-label {
        color: #00448b !important;
        font-size: 14px !important;
        font-weight: 600 !important;
    }
    .hide-state {
        visibility: hidden
    }
    .mx-datepicker.calendar-edit-per .mx-calendar-icon {
        stroke-width: 0px !important;
        background: url('/static/images/images-new-theme/icons/blue-calendar.svg') !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
    }
    .h-auto {
        height: auto !important;
    }
    .val-mes-dis{
        position: relative;
    }
    .val-mes{
        position: absolute;
        bottom: -100px;
    }
</style>


// WEBPACK FOOTER //
// src/components/Leads/ScheduleMeeting.vue